import { ChangeRequestTemplate } from '@app/models/change-requests/change-request-template.model';
import { Translatable } from '@app/types/translatable.type';
import { ChangeRequestTemplateDisplayOptions } from '@app/types/translatables/change-request-template-display.options';
import { Column } from '@table/classes/column.class';
import { CellDisplay } from '@table/enums/cell-display.enum';

export class NameColumn extends Column {
    title = 'change-requests.templateTable.name';
    type: CellDisplay = CellDisplay.string;
    property = 'name';

    getDisplayPropertyValue(changeRequestTemplate: ChangeRequestTemplate): Translatable {
        return ChangeRequestTemplateDisplayOptions[changeRequestTemplate.name] ?? changeRequestTemplate.name;
    }
}
